// =============================================================================
// dateConfig.ts — global date-library week-start configuration.
//
// The app renders calendars/date-pickers from two independent date stacks:
//   • dayjs   → every Ant Design <DatePicker> (antd v5's default engine)
//   • date-fns → the MUI x-date-pickers and the custom CompactWeekCalendar
//
// We want Monday as the leftmost day of the week everywhere. This module owns
// the dayjs side: it sets weekStart=1 on the default `en` locale so all antd
// pickers open on Monday, without changing date *formatting* (unlike switching
// to the `en-gb` locale). It is imported once for its side effects at app entry
// (src/index.js). The date-fns side is handled locally where the MUI
// LocalizationProvider / CompactWeekCalendar live (both pass a Monday-first
// locale / weekStartsOn: 1).
// =============================================================================

import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });

export {};
